module.exports = __webpack_public_path__ + "img/bg_slide_6.847747a5.jpg";